"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.regexp.match");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.regexp.constructor");
var _vgm = require("@/api/query/vgm");
var _validate = require("@/utils/validate");
var _xlsx = _interopRequireDefault(require("xlsx"));
var _onlineFile = require("@/api/onlineFile/onlineFile");
var _bookingHead = require("@/api/query/bookingHead");
var _deliveryInfo = _interopRequireDefault(require("../delivery/deliveryInfo"));
var _utils = require("@/utils");
var _importResultDialog = _interopRequireDefault(require("./components/importResultDialog"));
var _booking = require("@/api/bookSpace/booking");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//测试
//测试,通过
//测试，通过
var _default = exports.default = {
  name: 'vgmApply',
  components: {
    DeliveryInfo: _deliveryInfo.default,
    importResultDialog: _importResultDialog.default
  },
  data: function data() {
    var _this2 = this;
    var vm = window.vm;
    var pattern1 = new RegExp(/^[a-zA-Z]+$/i);
    var pattern2 = new RegExp(/^[0-9]+$/i);
    // rules条件
    var validateBKBLNo = function validateBKBLNo(rule, value, callback) {
      if ((0, _validate.validateNull)(_this2.bkVgmWeb.bkNo) && (0, _validate.validateNull)(_this2.bkVgmWeb.blNo)) {
        callback(new Error(_this2.$t('vgmInfo.bkblNoNotNull')));
      } else {
        callback();
      }
    };
    var validateVVL = function validateVVL(rule, value, callback) {
      if ((0, _validate.validateNull)(_this2.form.vesselCode) || (0, _validate.validateNull)(_this2.form.voyageNo) || (0, _validate.validateNull)(_this2.form.voyageLeg)) {
        callback(new Error(_this2.$t('vgmInfo.VVLNotNull')));
      } else {
        callback();
      }
    };
    var validateVVLInner = function validateVVLInner(rule, value, callback) {
      if ((0, _validate.validateNull)(_this2.bkVgmWeb.vesselCode) || (0, _validate.validateNull)(_this2.bkVgmWeb.voyageNo) || (0, _validate.validateNull)(_this2.bkVgmWeb.voyageLeg)) {
        callback(new Error(_this2.$t('vgmInfo.VVLNotNull')));
      } else {
        callback();
      }
    };
    //当舱单的pol是泰国出发的则查询泰国的VGM_LIMIT，超过限制的做错误提示。
    var validateWeight = function validateWeight(rule, value, callback) {
      if ((0, _validate.validateNull)(_this2.bkVgmWeb.vgmGrossWeight)) {
        callback(new Error(_this2.$t('vgmInfo.weightNotNull')));
      } else if (!((0, _validate.validateNull)(_this2.bkVgmWeb.bkNo) && (0, _validate.validateNull)(_this2.bkVgmWeb.blNo))) {
        (0, _bookingHead.getBookingInfo)(!(0, _validate.validateNull)(_this2.bkVgmWeb.bkNo) ? {
          bkNo: _this2.bkVgmWeb.bkNo
        } : !(0, _validate.validateNull)(_this2.bkVgmWeb.blNo) ? {
          blNo: _this2.bkVgmWeb.blNo
        } : {}).then(function (response) {
          if (response.data.records[0].pol.slice(0, 2) === 'TH') {
            (0, _vgm.getDocBasicConfig)({
              countryCode: 'TH',
              functionCode: 'VGM_LIMIT',
              active: '1'
            }).then(function (response) {
              if (_this2.bkVgmWeb.vgmGrossWeight < +response.data.records.filter(function (item) {
                return item.functionType === 'MIN';
              })[0].functionCodeValue || _this2.bkVgmWeb.vgmGrossWeight > +response.data.records.filter(function (item) {
                return item.functionType === 'MAX';
              })[0].functionCodeValue) {
                callback(new Error(_this2.$t('vgmInfo.weightAbnormal')));
              } else {
                callback();
              }
            });
          } else {
            callback();
          }
        });
      } else {
        callback();
      }
    };
    var validateContainerNo = function validateContainerNo(rule, value, callback) {
      if (!(_this2.bkVgmWeb.containerNo.length === 11 && pattern1.test(_this2.bkVgmWeb.containerNo.substring(0, 4)) && pattern2.test(_this2.bkVgmWeb.containerNo.substring(4, 11)))) {
        callback(new Error(_this2.$t('vgmInfo.containerMessage')));
      } else {
        callback();
      }
    };
    return {
      vm: vm,
      isCnLang: false,
      headers: {
        Authorization: 'SITCEB_BOOKING'
      },
      minioUrl: undefined,
      vvlVisible: false,
      vvlFrom: {
        vesselCode: '',
        vesselName: '',
        voyageNo: '',
        voyageLeg: ''
      },
      vvlPage: {
        current: 1,
        total: 0,
        pageSize: 5
      },
      importResultDialogVisible: false,
      importRes: null,
      notice: '',
      vvlData: [],
      blNo: '',
      containerNo: '',
      containerTypeOptions: [{
        label: '',
        value: ''
      }, {
        label: '20GP',
        value: '20GP'
      }
      // {label: '20FR', value: '20FR'},
      // {label: '20TK', value: '20TK'},
      // {label: '20HR', value: '20HR'},
      // {label: '20HC', value: '20HC'},
      // {label: '20OT', value: '20OT'},
      // {label: '20RF', value: '20RF'},
      // {label: '40GP', value: '40GP'},
      // {label: '40FR', value: '40FR'},
      // {label: '40TK', value: '40TK'},
      // {label: '40RF', value: '40RF'},
      // {label: '40HR', value: '40HR'},
      // {label: '40HC', value: '40HC'},
      // {label: '40OT', value: '40OT'},
      // {label: '45HR', value: '45HR'},
      // {label: '45HC', value: '45HC'}
      ],
      methodTypeOptions: [{
        label: '',
        value: ''
      }, {
        label: 'SM1',
        value: 1
      }, {
        label: 'SM2',
        value: 2
      }],
      scaleTypeOptions: [{
        label: '',
        value: ''
      }, {
        label: 'KGS',
        value: 1
      }, {
        label: 'LBS',
        value: 2
      }],
      activeNames: ['1'],
      bkVgmWeb: {
        bkVgmContainerId: '',
        vesselCode: '',
        voyageNo: '',
        voyageLeg: '',
        blNo: '',
        bkNo: '',
        containerNo: '',
        importFlag: '',
        vgmGrossWeight: '',
        vgmScale: '',
        vgmMethod: '',
        vgmDate: '',
        location: '',
        rejectReason: '',
        vesselName: '',
        containerType: '',
        containerOther: '',
        remark: '',
        shipperName: '',
        shipperAddress: '',
        shipperVgmName: '',
        shipperVgmEmail: '',
        shipperVgmTelephone: '',
        vgmCertificateId: '',
        shipperVgmPerson: '',
        shipperVgmPersonSig: '',
        vgmDeclarationParty: '',
        vgmEquipmentId: '',
        shipperOther: '',
        name: '',
        contactName: '',
        contactTelephone: '',
        address: '',
        contactEmail: '',
        contactPerson: '',
        contactPersonSig: '',
        contactOther: ''
      },
      bkVgmWebRules: {
        vesselCode: [{
          validator: validateVVLInner,
          trigger: ['change', 'blur']
        }],
        bkNo: [{
          validator: validateBKBLNo,
          trigger: ['change', 'blur']
        }],
        blNo: [{
          validator: validateBKBLNo,
          trigger: ['change', 'blur']
        }],
        containerNo: [{
          required: true,
          message: this.$t('validate.containerNo'),
          trigger: ['change', 'blur']
        }, {
          validator: validateContainerNo,
          trigger: ['change', 'blur']
        }],
        vgmMethod: [{
          required: true,
          message: this.$t('vgmInfo.methodNotNull'),
          trigger: ['change', 'blur']
        }],
        vgmGrossWeight: [{
          required: true,
          validator: validateWeight,
          trigger: ['change', 'blur']
        }],
        vgmScale: [{
          required: true,
          message: this.$t('vgmInfo.scaleNotNull'),
          trigger: ['change', 'blur']
        }],
        contactEmail: [{
          required: false,
          type: 'email',
          message: this.$t('validate.emailNotTrue'),
          trigger: ['blur', 'change']
        }],
        shipperVgmEmail: [{
          required: false,
          type: 'email',
          message: this.$t('validate.emailNotTrue'),
          trigger: ['blur', 'change']
        }]
      },
      vgmDeclareVisible: false,
      isResult: false,
      page: {
        total: 0,
        pageSize: 10
      },
      selectValue: 0,
      selectOptions: [{
        label: this.$t('vgmApply.bkNo'),
        value: 0
      }, {
        label: this.$t('vgmApply.blNo'),
        value: 1
      }, {
        label: this.$t('vgmApplyInfo.vvl'),
        value: 2
      }],
      uploadExcel: '/api/ebusiness/webBkVgmContainer/uploadExcel',
      excelField: ['bkNo', 'blNo', 'vesselCode', 'voyageNo', 'voyageLeg', 'conatinerNo', 'sealNo', 'conatinerType', 'vgmGrossWeight', 'vgmScale', 'vgmDate', 'vgmMethod', 'location', 'shipperName', 'shipperAddress', 'shipperVgmName', 'shipperVgmEmail', 'shipperVgmTelephone', 'shipperVgmPerson', 'shipperVgmPersonSig', 'vgmCertificateId', 'vgmDeclarationParty', 'vgmEquipmentId', 'name', 'address', 'contactName', 'contactEmail', 'contactTelephone', 'contactPerson', 'contactPersonSig'],
      excelParam: {
        excelData: '',
        excelArr: [{}]
      },
      fileList: [],
      importStatusOptions: [{
        label: this.$t('vgmApply.wait'),
        value: 1
      }, {
        label: this.$t('vgmApply.accepted'),
        value: 2
      }, {
        label: this.$t('vgmApply.refuse'),
        value: 3
      }],
      scaleTypeName: {
        '1': 'KGS',
        '2': 'LBS'
      },
      methodTypeName: {
        '1': 'SM1',
        '2': 'SM2'
      },
      importFlagName: {
        '1': 'WAITING',
        '2': 'RECEIVED',
        '3': 'REJECTED'
      },
      form: {
        blNo: '',
        containerNo: '',
        bkNo: '',
        vesselCode: '',
        voyageNo: '',
        voyageLeg: '',
        importFlag: '',
        rowStart: '1',
        // pageIndex: '1',
        pageSize: '10'
      },
      loading: null,
      baseInfo: [],
      formRules: {
        blNo: [{
          required: true,
          message: this.$t('validate.blNo'),
          trigger: ['change', 'blur']
        }],
        containerNo: [{
          required: true,
          message: this.$t('validate.containerNo'),
          trigger: ['change', 'blur']
        }],
        bkNo: [{
          required: true,
          message: this.$t('validate.bkNo'),
          trigger: ['change', 'blur']
        }],
        vesselCode: [{
          validator: validateVVL,
          trigger: ['change', 'blur']
        }]
      }
    };
  },
  //inject: ['reload'],
  methods: {
    validateNull: _validate.validateNull,
    getOnlineFile: _onlineFile.getOnlineFile,
    downloadFile: _vgm.downloadFile,
    getBookingInfo: _bookingHead.getBookingInfo,
    toReset: function toReset() {
      this.$refs.form.resetFields();
    },
    /**
     * currentPage 改变时会触发
     */
    handleCurChange: function handleCurChange(val) {
      this.form.rowStart = (val - 1) * this.form.pageSize + 1;
      this.toSearch();
    },
    /**
     * pageSize 改变时会触发
     */
    handleSizeChange: function handleSizeChange(val) {
      this.form.pageSize = val;
      this.toSearch();
    },
    //查询条件改变时，其他字段置空
    onChange: function onChange() {
      this.form.blNo = '';
      this.form.bkNo = '';
      this.form.vesselCode = '';
      this.form.voyageNo = '';
      this.form.voyageLeg = '';
    },
    // 下载导入模板
    downloadTemplate: function downloadTemplate() {
      this.minioUrl = this.GLOBAL.MINIO_URL;
      (0, _onlineFile.getOnlineFile)(['VGM_EXCELTEMPLATE']).then(function (response) {
        (0, _vgm.downloadFile)(response.data[0].functionValue, 'VGM_import_Format.xls');
      });
    },
    bkToVVL: function bkToVVL() {
      var _this3 = this;
      if (this.bkVgmWeb.bkNo) {
        (0, _vgm.searchVVL)({
          index: 1,
          no: this.bkVgmWeb.bkNo
        }).then(function (response) {
          if (!(0, _validate.validateNull)(response.data)) {
            //alert(response.data)
            _this3.bkVgmWeb.vesselCode = response.data[0].vesselCode;
            _this3.bkVgmWeb.voyageNo = response.data[0].voyageNo;
            _this3.bkVgmWeb.voyageLeg = response.data[0].voyageLeg;
            //alert(this.bkVgmWeb.voyageLeg)
          }
        });
      }
    },
    blToVVL: function blToVVL() {
      var _this4 = this;
      if (this.bkVgmWeb.blNo) {
        (0, _vgm.searchVVL)({
          index: 0,
          no: this.bkVgmWeb.blNo
        }).then(function (response) {
          if (!(0, _validate.validateNull)(response.data)) {
            //alert(response.data)
            _this4.bkVgmWeb.vesselCode = response.data[0].vesselCode;
            _this4.bkVgmWeb.voyageNo = response.data[0].voyageNo;
            _this4.bkVgmWeb.voyageLeg = response.data[0].voyageLeg;
            // alert(response.data[0].vesselCode)
            // alert(this.bkVgmWeb.voyageLeg)
          }
        });
      }
    },
    // 查找船名航次
    vesselCodeChange: function vesselCodeChange(value, selectedRows) {
      this.vvlFrom.vesselCode = selectedRows.vesselCode;
    },
    onShow: function onShow() {
      this.vvlVisible = true;
      this.searchVVL();
    },
    onClose: function onClose() {
      this.vvlVisible = false;
      this.vvlData = [];
    },
    // 新增页面中的查找船名航次
    searchVVL: function searchVVL() {
      var _this5 = this;
      (0, _vgm.getVVLInfo)(Object.assign({
        pageSize: this.vvlPage.pageSize,
        currentPage: this.vvlPage.current
      }, this.vvlFrom)).then(function (response) {
        _this5.vvlData = response.data.records;
        _this5.vvlPage.total = response.data.totalRecord;
      });
    },
    resetFn: function resetFn() {
      this.vvlFrom.vesselCode = '';
      this.vvlFrom.vesselName = '';
      this.vvlFrom.voyageLeg = '';
      this.vvlFrom.voyageNo = '';
    },
    // 点击之后对表单赋值
    fillVVL: function fillVVL(row) {
      this.bkVgmWeb.vesselCode = row.vesselCode;
      this.bkVgmWeb.voyageNo = row.voyageNo;
      this.bkVgmWeb.voyageLeg = row.voyageLeg;
      this.onClose();
    },
    /**
     * currentPage 改变时会触发
     */
    handleCurrentChange: function handleCurrentChange(val) {
      this.vvlPage.current = val;
      this.searchVVL();
    },
    //表单太大，验证消息通过message提示，不然用户看不到上面的校验信息
    //保存并拷贝
    saveAndCopy: function saveAndCopy(bkVgmWeb) {
      var _this6 = this;
      this.$refs.bkVgmWeb.validate(function (valid, obj) {
        if (valid) {
          var _obj = _this6.bkVgmWeb;
          (0, _vgm.addBkVgmWeb)(_obj).then(function (response) {
            if (response.success === true) {
              var type = '';
              if (response.data.includes('成功') || response.data.includes('success')) {
                type = 'success';
              } else {
                type = 'warning';
              }
              _this6.$message({
                showClose: true,
                message: response.data.replace(/\n/g, '<br>'),
                //this.$t('validate.containerNo')
                type: type,
                dangerouslyUseHTMLString: true
              });
              _this6.toSearch();
              _this6.bkVgmWeb.bkVgmContainerId = '';
              _this6.bkVgmWeb.containerNo = '';
              _this6.bkVgmWeb.vgmGrossWeight = '';
            } else {
              if (response.errorMessages !== '') {
                _this6.$message({
                  showClose: true,
                  type: 'error',
                  message: response.errorMessages[0]
                });
              } else {
                _this6.$message({
                  showClose: true,
                  message: _this6.$t('vgmApply.addFail'),
                  type: 'warning'
                });
              }
            }
          });
        } else {
          var a = [];
          for (var key in obj) {
            a.push(obj[key][0].message);
          }
          _this6.$message({
            message: a,
            type: 'warning'
          });
          return false;
        }
      });
    },
    //保存并新增，保存完了，新增页面置空
    saveAndNew: function saveAndNew(bkVgmWeb) {
      var _this7 = this;
      this.$refs[bkVgmWeb].validate(function (valid, obj) {
        if (valid) {
          var _obj2 = _this7.bkVgmWeb;
          (0, _vgm.addBkVgmWeb)(_obj2).then(function (response) {
            if (response.success === true) {
              var type = '';
              if (response.data.includes('成功') || response.data.includes('success')) {
                type = 'success';
              } else {
                type = 'warning';
              }
              _this7.$message({
                showClose: true,
                message: response.data.replace(/\n/g, '<br>'),
                type: type,
                dangerouslyUseHTMLString: true
              });
              _this7.toSearch();
              _this7.$refs.bkVgmWeb.resetFields();
              _this7.bkVgmWeb.voyageNo = '';
              _this7.bkVgmWeb.voyageLeg = '';
            } else {
              if (response.errorMessages !== '') {
                _this7.$message({
                  showClose: true,
                  type: 'error',
                  message: response.errorMessages[0]
                });
              } else {
                _this7.$message({
                  showClose: true,
                  message: _this7.$t('vgmApply.addFail'),
                  type: 'warning'
                });
              }
            }
          });
        } else {
          var a = [];
          for (var key in obj) {
            a.push(obj[key][0].message);
          }
          _this7.$message({
            message: a,
            type: 'warning'
          });
          return false;
        }
      });
    },
    //保存，完了直接关闭新增界面
    addBkVgmWeb: function addBkVgmWeb(bkVgmWeb) {
      var _this8 = this;
      this.$refs[bkVgmWeb].validate(function (valid, obj) {
        if (valid) {
          var _obj3 = _this8.bkVgmWeb;
          (0, _vgm.addBkVgmWeb)(_obj3).then(function (response) {
            if (response.success === true) {
              var type = '';
              if (response.data.includes('成功') || response.data.includes('success')) {
                type = 'success';
                _this8.vgmDeclareVisible = false;
              } else {
                type = 'warning';
              }
              _this8.$message({
                showClose: true,
                message: response.data.replace(/\n/g, '<br>'),
                type: type,
                dangerouslyUseHTMLString: true
              });
              _this8.toSearch();
            } else {
              if (response.errorMessages !== '') {
                _this8.$message({
                  showClose: true,
                  type: 'error',
                  message: response.errorMessages[0]
                });
              } else {
                _this8.$message({
                  showClose: true,
                  message: _this8.$t('vgmApply.addFail'),
                  type: 'warning'
                });
              }
            }
          });
        } else {
          var a = [];
          for (var key in obj) {
            a.push(obj[key][0].message);
          }
          _this8.$message({
            message: a,
            type: 'warning'
          });
          return false;
        }
      });
    },
    back: function back() {
      this.vgmDeclareVisible = false;
    },
    toSearch: function toSearch() {
      var _this9 = this;
      this.$refs.form.validate(function (valid, obj) {
        if (valid) {
          _this9.loading = (0, _utils.load)();
          (0, _vgm.vgmApplyQuery)(_this9.form).then(function (response) {
            if ((0, _validate.validateNull)(response.data.list)) {
              _this9.isResult = true;
              _this9.baseInfo = [];
            } else {
              _this9.baseInfo = response.data.list;
              _this9.page.total = +_this9.baseInfo[0].totalcount;
              _this9.isResult = true;
            }
          }).finally(function () {
            _this9.loading.close();
          });
        } else {
          _this9.isResult = false;
          _this9.baseInfo = [];
        }
      });
    },
    handleEdit: function handleEdit(row) {
      var _this10 = this;
      if (!(0, _validate.validateNull)(row.bkVgmContainerId)) {
        this.vgmDeclareVisible = true;
        (0, _vgm.getVgmInfo)(row.bkVgmContainerId).then(function (response) {
          _this10.$nextTick(function () {
            this.bkVgmWeb = response.data;
          });
        });
      }
    },
    handleDelete: function handleDelete(row) {
      var _this11 = this;
      this.$confirm(this.$t('vgmApply.delConfirm')).then(function (_) {
        (0, _vgm.delObj)(row.bkVgmContainerId).then(function (data) {
          if (data.success === true) {
            _this11.$message({
              showClose: true,
              message: _this11.$t('vgmApply.delSuccess'),
              type: 'success'
            });
            _this11.baseInfo = [];
            _this11.toSearch();
          } else {
            _this11.$message({
              showClose: true,
              message: _this11.$t('vgmApply.delFail'),
              type: 'warning'
            });
          }
        });
      }).catch(function (_) {});
    },
    addVgmInfo: function addVgmInfo() {
      this.vgmDeclareVisible = true;
      this.bkVgmWeb.voyageNo = '';
      this.bkVgmWeb.voyageLeg = '';
      this.$refs.bkVgmWeb.resetFields();
    },
    handleCopy: function handleCopy(row) {
      var _this12 = this;
      if (!(0, _validate.validateNull)(row.bkVgmContainerId)) {
        this.vgmDeclareVisible = true;
        (0, _vgm.getVgmInfo)(row.bkVgmContainerId).then(function (response) {
          _this12.$nextTick(function () {
            this.bkVgmWeb = response.data;
            this.bkVgmWeb.bkVgmContainerId = '';
            this.bkVgmWeb.containerNo = '';
            this.bkVgmWeb.vgmGrossWeight = '';
            this.bkVgmWeb.rejectReason = '';
          });
        });
      }
    },
    // 导入Excel
    handleSuccess: function handleSuccess(res, file, index) {
      this.loading.close();
      this.isCnLang = this.$i18n.locale === 'zh';
      if (res.success === true) {
        if (res.data[0] === true) {
          this.$message({
            type: 'success',
            message: this.isCnLang ? res.data[1] : res.data[2],
            duration: 6000
          });
          this.fileList = this.fileList.slice(-1);
          this.fileList = [];
        } else {
          if (res.data.length > 3) {
            if (res.data[3].length > 0) {
              this.importRes = res.data[3];
            }
            this.notice = this.isCnLang ? res.data[1] : res.data[2];
            this.importResultDialogVisible = true;
            this.fileList = [];
          } else {
            if (!(0, _validate.validateNull)(res.data[1]) && !(0, _validate.validateNull)(res.data[2])) {
              this.$message({
                type: 'error',
                message: this.isCnLang ? res.data[1] : res.data[2],
                duration: 6000
              });
              this.fileList = [];
            } else if (!(0, _validate.validateNull)(res.data[0]) && !(0, _validate.validateNull)(res.data[1])) {
              this.$message({
                type: 'error',
                message: this.isCnLang ? res.data[0] : res.data[1],
                duration: 6000
              });
              this.fileList = [];
            } else {
              this.$message({
                type: 'info',
                message: this.$t('vgmApply.failures'),
                duration: 6000
              });
              this.fileList = [];
            }
          }
        }
      } else {
        this.$message({
          type: 'error',
          message: res.errorMessages[0],
          duration: 6000
        });
        this.fileList = [];
      }
    },
    handleBeforeUpload: function handleBeforeUpload(file) {
      var _this = this;
      return new Promise(function (resolve, reject) {
        var _this13 = this;
        _this.readExcel(file).then(function (result) {
          var isLt2M = file.size / 1024 / 1024 < 0.5;
          if (!isLt2M) {
            _this.$message.error(_this13.$t('vgmApply.fileSize'));
          }
          if (isLt2M && result) {
            resolve(vm.$t('vgmApply.checkSuccess'));
          }
        }, function (error) {
          _this.$message.error(error);
        });
      });
    },
    readExcel: function readExcel(file) {
      this.loading = (0, _utils.load)();
      var _this = this;
      _this.excelParam.excelArr = [];
      _this.excelParam.excelData = '';
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function (e) {
          var workbook;
          try {
            var data = e.target.result;
            workbook = _xlsx.default.read(data, {
              type: 'binary'
            });
          } catch (e) {
            reject(e.message);
          }
          var excelJson = {};
          var excelArr = [];
          var fromTo = '';
          for (var sheet in workbook.Sheets) {
            var sheetInfos = workbook.Sheets[sheet];
            var locations = [];
            if (workbook.Sheets.hasOwnProperty(sheet)) {
              fromTo = sheetInfos['!ref'];
              locations = _this.getLocationsKeys(fromTo);
            }
            for (var i = 0; i < locations.length; i++) {
              var value = '';
              try {
                value = sheetInfos[locations[i]].v;
              } catch (e) {}
              if (i < 30) {
                if (_this.excelField[i] === 'vgmDate') {
                  value = _this.formatDate(value, '/');
                  excelJson[_this.excelField[i]] = value + '';
                } else if (_this.excelField[i] === 'vgmScale') {
                  if ((0, _validate.validateNull)(value)) {
                    value = '';
                  } else if (value.toString().toUpperCase() === 'KGS') {
                    value = 1;
                  } else if (value.toString().toUpperCase() === 'LBS') {
                    value = 2;
                  } else {
                    value = 3;
                  }
                  excelJson[_this.excelField[i]] = value + '';
                } else if (_this.excelField[i] === 'vgmMethod') {
                  if ((0, _validate.validateNull)(value)) {
                    value = '';
                  } else if (value.toString().toUpperCase() === 'SM1') {
                    value = 1;
                  } else if (value.toString().toUpperCase() === 'SM2') {
                    value = 2;
                  }
                  excelJson[_this.excelField[i]] = value + '';
                } else {
                  excelJson[_this.excelField[i]] = value + '';
                }
              } else {
                if (_this.excelField[i - 30 * Math.floor(i / 30)] === 'vgmDate') {
                  value = _this.formatDate(value, '/');
                  excelJson[_this.excelField[i - 30 * Math.floor(i / 30)]] = value + '';
                } else if (_this.excelField[i - 30 * Math.floor(i / 30)] === 'vgmScale') {
                  if ((0, _validate.validateNull)(value)) {
                    value = '';
                  } else if (value.toString().toUpperCase() === 'KGS') {
                    value = 1;
                  } else if (value.toString().toUpperCase() === 'LBS') {
                    value = 2;
                  } else {
                    value = 3;
                  }
                  excelJson[_this.excelField[i - 30 * Math.floor(i / 30)]] = value + '';
                } else if (_this.excelField[i - 30 * Math.floor(i / 30)] === 'vgmMethod') {
                  if ((0, _validate.validateNull)(value)) {
                    value = '';
                  } else if (value.toString().toUpperCase() === 'SM1') {
                    value = 1;
                  } else if (value.toString().toUpperCase() === 'SM2') {
                    value = 2;
                  }
                  excelJson[_this.excelField[i - 30 * Math.floor(i / 30)]] = value + '';
                } else {
                  excelJson[_this.excelField[i - 30 * Math.floor(i / 30)]] = value + '';
                }
              }
              if ((i + 1) % 30 === 0) {
                excelArr.push(excelJson);
                excelJson = {};
              }
            }
            resolve(true);
          }
          _this.excelParam.excelData = JSON.stringify(excelArr);
        };
        reader.readAsBinaryString(file);
      });
    },
    getLocationsKeys: function getLocationsKeys(range) {
      var rangeArr = range.split(':');
      var endString = rangeArr[1];
      var reg = /[A-Z]{1,}/g;
      var end = endString.match(reg)[0];
      var endMath = endString.split(endString.match(reg)[0])[1];
      var total = 0; // 共有多少个
      for (var index = 0; index < end.length; index++) {
        total += Math.pow(26, end.length - index - 1) * (end.charCodeAt(index) - 64);
      }
      var result = [];
      for (var j = 3; j <= endMath; j++) {
        var excelKey = [];
        for (var i = 0; i < total; i++) {
          result.push(this.getCharByNum(i) + j);
          excelKey[i] = this.getCharByNum(i) + j;
        }
        if (excelKey !== []) {
          this.excelParam.excelArr[j - 3] = excelKey;
        }
      }
      return result;
    },
    handelOnError: function handelOnError(msg) {
      this.loading.close();
      this.isCnLang = this.$i18n.locale === 'zh';
      alert(JSON.stringify(msg));
      //alert("error")
      this.$message.error(this.isCnLang ? msg[0] : msg[1]);
    },
    getCharByNum: function getCharByNum(index) {
      var a = parseInt(index / 26);
      var b = index % 26;
      var returnChar = String.fromCharCode(b + 65);
      while (a > 0) {
        b = a % 26;
        a = parseInt(a / 26);
        returnChar = String.fromCharCode(b + 65 - 1) + returnChar;
      }
      return returnChar;
    },
    formatDate: function formatDate(numb, format) {
      if ((0, _validate.validateNull)(numb)) {
        return '';
      }
      var old = numb - 1;
      var t = Math.round((old - Math.floor(old)) * 24 * 60 * 60);
      var time = new Date(1900, 0, old, 0, 0, t);
      var year = time.getFullYear();
      var month = time.getMonth() + 1;
      var date = time.getDate();
      return year + format + (month < 10 ? '0' + month : month) + format + (date < 10 ? '0' + date : date);
    },
    // 获取包装类型
    queryListPackageType: function queryListPackageType() {
      var _this14 = this;
      var data = {
        pageSize: 1000,
        currentPage: 1
      };
      (0, _booking.queryListCode)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
        type: "EQUIPMENT"
      })).then(function (res) {
        _this14.containerTypeOptions = res.data || [];
      });
    }
  },
  created: function created() {
    this.isCnLang = this.$i18n.locale === 'zh';
    this.queryListPackageType();
  }
};